/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description Component for Resubmit Claim Button
 */
import { Button, ButtonProps, App } from 'antd';
import { useNavigate } from 'react-router-dom';

import { getClaimsResubmitRequestPath } from 'utils/router';
import { MODAL_TYPES } from 'components/widgets/modal';

// todo: condition to be added later
// const getMessage = (isPaymentPosted: boolean): string => {
// 	if (isPaymentPosted) {
// 		return 'This claim has a payment posted. Resubmitting will unallocate that payment from this claim. Do you want to continue?';
// 	}
// 	return `You’re about to open this claim for resubmission. Do you want to continue?`;
// };

/**
 * Resubmit Claim
 */
const ResubmitClaim: React.FC<ButtonProps & { id: string }> = ({ id, ...props }) => {
	const { modal } = App.useApp();
	const navigate = useNavigate();

	const handleResubmitClick = () => {
		modal.confirm({
			...MODAL_TYPES.confirm,
			width: 500,
			content: 'Do you want to proceed to edit and resubmit this claim?',
			okText: 'Continue',
			cancelText: 'Cancel',
			okButtonProps: { 'data-testid': 'rsb-resubmit-confirm' },
			cancelButtonProps: { 'data-testid': 'rsb-resubmit-cancel' },
			onOk: () => {
				navigate(getClaimsResubmitRequestPath(id));
			},
		});
	};

	return (
		<Button type='primary' onClick={handleResubmitClick} {...props} data-testid='rsb-resubmit-btn'>
			{'Resubmit Claim'}
		</Button>
	);
};

export default ResubmitClaim;
